// extracted by mini-css-extract-plugin
export default {"acceptButton":"_-_-record-it-components-src-modal-EditDialog-__acceptButton"};